import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";
// The apps' own switch (Profil › Réduire les animations), kept on the device.
const KEY = "tk_reduce_motion";
// A browser that cannot answer (no matchMedia: very old ones, the test
// runner) gets the still page, never a motion it could not stop.
const ask = () => typeof window === "undefined" || typeof window.matchMedia !== "function" || Boolean(window.matchMedia(QUERY)?.matches);
const stored = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

/**
 * The profile switch: applies at once, everywhere, without a reload. The
 * class it sets on <html> is what index.css reads (tk-reduce-motion).
 */
export function setReduceMotion(on) {
  try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* private storage */ }
  document.documentElement.classList.toggle("tk-reduce-motion", Boolean(on));
  window.dispatchEvent(new Event("tk-reduce-motion"));
}
export const reduceMotionSetting = stored;

/** True while the visitor (the phone's setting or the profile switch) asks for less motion; follows both live. */
export default function useReducedMotion() {
  const [os, setOs] = useState(ask);
  const [app, setApp] = useState(stored);
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.classList.toggle("tk-reduce-motion", stored());
    const onApp = () => setApp(stored());
    window.addEventListener("tk-reduce-motion", onApp);
    if (typeof window.matchMedia !== "function") return () => window.removeEventListener("tk-reduce-motion", onApp);
    const media = window.matchMedia(QUERY);
    const follow = () => setOs(Boolean(media.matches));
    media.addEventListener?.("change", follow);
    return () => {
      media.removeEventListener?.("change", follow);
      window.removeEventListener("tk-reduce-motion", onApp);
    };
  }, []);
  return os || app;
}
